/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export const splitAddress = (address: string) => {
  let parts = address.split(', ');
  parts = parts.length === 1 ? address.split('\n') : parts;
  return {
    first: parts[0],
    second: parts
      .filter((_) => _.trim() !== '')
      .slice(1)
      .join(', ')
      .trim(),
  };
};
